<template>
  <ReactSiteFrame :src="src" />
</template>
<script>
import ReactSiteFrame from '../components/react/iframe'

export default {
  name: 'BranchesReact',
  components: {
    ReactSiteFrame
  },
  data() {
    return {
      src: `/view/branches`
    }
  }
}
</script>
